import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Form, Select, Input, DatePicker, Tooltip, Radio, Checkbox, Button, Space, Popconfirm, Empty } from 'antd';
import Header from "../../components/Header"
import Footer from '../../components/Footer';
import api from '../../services/api';
import { message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import 'antd/dist/antd.css';


import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao';
import modalStatus from '../../redux/reducers/permissao';
import Permissao from '../Permissao';



import ModalNovaEscolaridade from './ModalNovaEscolaridade';
import ModalEditarEscolaridade from './ModalEditarEscolaridade';
import { escolaridadeService } from '../../services/Escolaridade-Service/escolaridade-service';

interface EscolaridadeProps {
    permissao?: any
}

const Escolaridade: React.FC<EscolaridadeProps> = (prop) => {
    const [dados, setDados] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    const [novaEscolaridadeModal, setNovaEscolaridadeModal] = useState(false)
    const [editarEscolaridadeModal, setEditarEscolaridadeModal] = useState<{ visivel: boolean, dado: any }>({ visivel: false, dado: null })
    useEffect(() => {
        Buscar({});
    }, [])

    const Buscar = async (values: any) => {
        setLoading(true);
        escolaridadeService.getComFiltros(values.descricao, values.estudando).then((response) => {
            setDados(response.data)

        })
            .finally(() => {
                setLoading(false);
            })
    };

    const excluir = (escolaridadeID: number) => {
        setLoading(true)
        escolaridadeService.delete(escolaridadeID).then((response) => {
            if (response.data.valido) {
                message.success('Escolaridade excluída com sucesso')
                Buscar({})
            }
            else {
                message.error(response.data.error)
            }
        })
        .finally(()=> setLoading(false))
    }

    const columns: ColumnsType<any> = [
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            width: '40%'
        },
        {
            title: 'Estudando',
            dataIndex: 'estudando',
            width: '5%',
            align: 'center',
            render: (text: any, record: any) => (<p>{record.estudando ? 'Sim' : 'Não'}</p>)
        },
        {
            title: 'Ações',
            width: '10%',
            key: 'action',
            align: 'center',
            render: (text, record: any) => (
                <Space size="middle">

                    {prop.permissao[0].permissaoAcesso?.editar === true ?
                        <Button htmlType="button" onClick={() => setEditarEscolaridadeModal({ visivel: true, dado: record })}>Editar</Button>
                        : null}
                    {prop.permissao[0].permissaoAcesso?.excluir === true ?
                        <Popconfirm key={record.escolaridadeID} placement="top" title="Você tem certeza que deseja excluir essa escolaridade?" onConfirm={() => { excluir(record.escolaridadeID) }} okText="Sim" cancelText="Não">
                            <Button htmlType="button" danger >Excluir</Button>
                        </Popconfirm>
                        : null}
                </Space>
            ),
            fixed: 'right' as 'right',
        }
    ];

    return (
        <div>
            <Header></Header>
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Spin spinning={loading}>
                        <Form onFinish={Buscar}
                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            layout="horizontal"
                            size="middle"
                        >
                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Descrição"
                                        name="descricao"
                                    >
                                        <Input placeholder="Informe a descrição da escolaridade" />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="Estudando"
                                        name="estudando"
                                        initialValue={null}
                                    >
                                        <Select placeholder="selecione">
                                            <Option value={null}>Selecione</Option>
                                            <Option value={true}>Sim</Option>
                                            <Option value={false}>Não</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item className="buttons">
                                {prop.permissao[0].permissaoAcesso?.cadastrar === true ?
                                    <Button className="button-novo" onClick={() => setNovaEscolaridadeModal(true)} type="ghost" htmlType="button">
                                        Nova Escolaridade
                                    </Button>
                                    : null}
                                <Button className="button-filtrar" type="primary" htmlType="submit">
                                    Filtrar
                                </Button>
                            </Form.Item>
                        </Form>
                    </Spin>
                </fieldset>
                <br />
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Table
                            locale={{ emptyText: <Empty description="Sem registro!" image={Empty.PRESENTED_IMAGE_SIMPLE}></Empty> }}
                            pagination={{ pageSize: 6 }}
                            size={'small'}
                            loading={loading} columns={columns} dataSource={dados} rowKey={"escolaridadeID"} bordered={true}></Table>
                    </Col>
                </Row>
            </div>
            <Footer></Footer>
            <ModalNovaEscolaridade
                atualizarConsulta={() => Buscar({})}
                visivel={novaEscolaridadeModal} fecharModal={() => setNovaEscolaridadeModal(false)}></ModalNovaEscolaridade>
            <ModalEditarEscolaridade
                atualizarConsulta={() => Buscar({})}
                escolaridade={editarEscolaridadeModal.dado} visivel={editarEscolaridadeModal.visivel} fecharModal={() => setEditarEscolaridadeModal({ visivel: false, dado: null })}></ModalEditarEscolaridade>
        </div>

    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(Escolaridade);